import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export function instructor_invitations_list(componentDataSourceService: ComponentDataSourceService) {
  return {
    name: 'Instruktørinvitationer',
    description: 'Liste over instruktørinvitationer',
    execute: (params?: LoadDataParams): Observable<any> => {
      const requestParams: LoadDataParams = {
        ...(params || {} as any),
        dataSourceKey: 'instructor_invitations_list',
        filters: params?.filters || []
      };
      return componentDataSourceService['loadDataWithStandardFiltersGET'](
        'instructor_invitations_list',
        '/events/instructor-invitations',
        requestParams
      ).pipe(
        catchError(error => {
          console.error('Error fetching instructor invitations:', error);
          return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
        }),
        map(result => {
          const items = result?.items ?? result?.data ?? [];
          const meta = result?.meta ?? {};
          return {
            items,
            totalCount: result?.totalCount ?? meta?.totalItems ?? items.length,
            pageSize: result?.pageSize ?? meta?.pageSize ?? 10,
            pageIndex: result?.pageIndex ?? (meta?.page != null ? meta.page - 1 : 0),
            filters: result?.filters
          };
        })
      );
    },
    settings: {
      pageSize: 10,
      pageSizeOptions: [10, 25, 50],
      columns: [
        { key: 'response_deadline', header: 'Svarfrist', type: 'date', sortable: true },
        { key: 'status_display', header: 'Status', type: 'text', sortable: true },
        { key: 'event_count', header: 'Antal events', type: 'text', sortable: true, alignment: 'right' as const },
        { key: 'invitee_count', header: 'Antal inviterede', type: 'text', sortable: true, alignment: 'right' as const },
        { key: 'created_at', header: 'Oprettet', type: 'date', sortable: true }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      searchable: false,
      defaultSortColumn: 'response_deadline',
      defaultSortDirection: 'desc',
      rowClickable: true,
      onRowClick: (row: any) => {
        window.dispatchEvent(new CustomEvent('duna-instructor-invitation-open', { detail: row }));
      }
    }
  };
}
